import SearchIcon from '@/assets/icon/search.svg';

interface SearchBarProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  placeholder: string;
  isSearching: boolean;
}

export function SearchBar({
  searchQuery,
  onSearchChange,
  placeholder,
  isSearching,
}: SearchBarProps) {
  return (
    <div className="relative w-full sm:w-64">
      <SearchIcon className="text-qf-black absolute top-1/2 left-2 h-4 w-4 -translate-y-1/2 transform" />
      <input
        type="text"
        placeholder={placeholder}
        className="text-qf-black w-full rounded-lg border border-gray-300 py-2 pr-4 pl-10 focus:border-transparent focus:ring-2 focus:ring-indigo-800 focus:outline-none"
        value={searchQuery}
        onChange={event => onSearchChange(event.target.value)}
      />
      {isSearching && (
        <div className="absolute top-1/2 right-3 -translate-y-1/2 transform">
          <div className="h-4 w-4 animate-spin rounded-full border-b-2 border-indigo-800"></div>
        </div>
      )}
      {searchQuery && !isSearching && (
        <button
          onClick={() => onSearchChange('')}
          className="absolute top-1/2 right-3 -translate-y-1/2 transform text-gray-400 hover:text-gray-600"
        >
          ✕
        </button>
      )}
    </div>
  );
}
